/**
 * Create an HTML element from an HTML string.
 *
 * @param {string} html - The HTML string to parse.
 * @returns {Node} The cloned DOM node.
 */
export function createHtmlElement(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const content = doc.body.firstChild;

    if (!content) {
        throw new Error("Failed to parse HTML string into a DOM node.");
    }

    return content.cloneNode(true);
}

/**
 * Toggle the visibility of an element by adding or removing the `d-none` class.
 *
 * @param {string} selector - A CSS selector for the target element.
 * @param {boolean} [visible=false] - Whether the element should be visible.
 * @returns {void}
 */
export function setElementVisibility(selector, visible = false) {
    const element = document.querySelector(selector);
    if (!element) return;
    element.classList.toggle("d-none", !visible);
}

/**
 * Add the `active` class to elements matching the given selectors within a parent element.
 *
 * @param {string} id - The ID of the parent element.
 * @param {string[]} selectors - An array of CSS selectors to activate within the parent.
 * @returns {void}
 */
export function activateClasses(id, selectors) {
    const element = document.getElementById(id);

    if (!element) return;

    selectors.forEach((/** @type {string} */ selector) => {
        const child = element.querySelector(selector);
        if (child) {
            child.classList.add("active");
        }
    });
}

export { registerAutoOpenFromUrl } from "./helpers/auto-open";
export { slideDown, slideToggle, slideUp } from "./animation";
export { on } from "./delegate";
